import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, getToken } from "./firebase";

// Obtiene la sesión actual: usa auth.currentUser si ya está disponible,
// o espera al primer evento de onAuthStateChanged si Firebase todavía no inicializó.
export const getSession = () => {
  return new Promise((resolve, reject) => {
    const resolveUser = async (user) => {
      if (!user) {
        resolve(null);
        return;
      }
      try {
        const idToken = await getToken(user);
        resolve({ email: user.email, uid: user.uid, idToken });
      } catch (error) {
        reject(error);
      }
    };

    if (auth.currentUser) {
      resolveUser(auth.currentUser);
      return;
    }

    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        unsubscribe();
        resolveUser(user);
      },
      (error) => {
        unsubscribe();
        reject(error);
      }
    );
  });
};

export const endSession = async () => {
  try {
    await signOut(auth);
    return true;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const isLoggedIn = async () => {
  const user = await getSession();
  return !!user;
};
